<script>
import Panel from '@phoenix/mixins/components/common/Panel';

export default {
  mixins: [Panel],

  props: {
    headerBordered: {
      type: Boolean,
      default: false,
    },
    footerBordered: {
      type: Boolean,
      default: false,
    },
    bodyDataCy: {
      type: String,
      default: '',
    },
  },

  computed: {
    _classes() {
      return ['panel', { 'panel--right': this.reverse }, ...this.classes];
    },

    _headerClasses() {
      return ['container', 'panel__header', { 'panel__header--bordered': this.headerBordered }, ...this.headerClasses];
    },

    _contentClasses() {
      return ['panel__content', 'flex-1', ...this.contentClasses];
    },

    _footerClasses() {
      return ['panel__footer', { 'panel__footer--bordered': this.footerBordered }];
    },
  },
};
</script>

<template>
  <div :id="id" :class="_classes" aria-hidden="true">
    <div class="panel__overlay" :data-panel-close="id"></div>

    <div class="panel__body" :data-cy="bodyDataCy">
      <header :class="_headerClasses">
        <div v-if="hasTitle" class="h5 text-md flex-1 pe-5 -mb-1">
          <h2 class="h5 mt-1">{{ title }}</h2>
        </div>

        <button
          class="button button--icon button--close button--light"
          type="button"
          :data-panel-close="id"
          aria-expanded="false"
        ></button>
      </header>

      <div :class="_contentClasses">
        <slot name="content"></slot>
      </div>

      <div v-if="hasFooterSlot" :class="_footerClasses">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>
